import { withVersions } from "v2/hocs/withVersions";
import TabsGroupUIV1 from "./TabsGroup/v1";
import TabBodyV1 from "./TabBody/v1";

const Tabs = {
  Group: withVersions({
    v1: TabsGroupUIV1,
    v2: TabsGroupUIV1,
  }),
  Body: withVersions({
    v1: TabBodyV1,
    v2: TabBodyV1,
  }),
};

export default Tabs;
